
































































import { Component, Vue, Mixins } from "vue-property-decorator";
import myMixins from "@/global/mixin";
import { banner, publicNotice } from "@/api/user/user";
import moment from "moment";

@Component
export default class Content extends Mixins(myMixins) {
  private bannerList: object[] = [];
  private banner2List: object[] = [];
  private noticeList: object[] = [];

  //获取 banner
  private async getList() {
    this.bannerList = [];
    try {
      const data: any = await banner("1003");
      this.$nextTick(() => {
        var result = data ? data.result : [];
        if (result.length % 3 == 1) {
          result.splice(result.length - 1, 0, result[result.length - 3]);
          result.splice(result.length - 1, 0, result[result.length - 3]);
        } else if (result.length % 3 == 2) {
          result.splice(result.length - 2, 0, result[result.length - 3]);
        }
        result.forEach((element) => {
          element["style"] =
            "height: 320px; width: 300px; background: url('" +
            element.image +
            "') no-repeat center center;backgroundSize: 100% 100%;cursor: pointer;border-radius:5px";
        });

        let index = 0;
        let newArray = [];
        while (index < result.length) {
          newArray.push(result.slice(index, (index += 3)));
        }
        this.bannerList = newArray;
      });
    } catch (err) {
      console.log(err);
    }

    this.banner2List = [];
    try {
      const data: any = await banner("1004");
      this.$nextTick(() => {
        var result = data ? data.result : [];
        if (result.length % 3 == 1) {
          result.splice(result.length - 1, 0, result[result.length - 3]);
          result.splice(result.length - 1, 0, result[result.length - 3]);
        } else if (result.length % 3 == 2) {
          result.splice(result.length - 2, 0, result[result.length - 3]);
        }
        result.forEach((element) => {
          element["style"] =
            "height: 320px; width: 300px; background: url('" +
            element.image +
            "') no-repeat center center;backgroundSize: 100% 100%;cursor: pointer;border-radius:5px";
        });

        let index = 0;
        let newArray = [];
        while (index < result.length) {
          newArray.push(result.slice(index, (index += 3)));
        }
        this.banner2List = newArray;
      });
    } catch (err) {
      console.log(err);
    }
  }

  private async getNotice() {
    let param = {
      status: 0,
      page: 1,
      pagesize: 3,
    };

    const data: any = await publicNotice(param);
    this.$nextTick(() => {
      if (data.code == "200" && data.result.rows) {
        this.noticeList = data.result.rows;
        this.noticeList.forEach((item, index) => {
          (item as any).time = moment((item as any).time * 1000).format(
            "YYYY-MM-DD"
          );
        });
      }
    });
  }

  private openNotice(item) {
    let userInfo = this.$store.state.userInfo;
    if (!(userInfo && userInfo.id)) {
      this.$Message.error("请登录后查看");
      return;
    }
    if (userInfo.isShowTagger) {
      this.$Message.error("您没有权限查看");
      return;
    }
    if (item.type == 1) {
      window.open(item.message, "_blank");
    }
  }

  private openAllNotice() {
    this.$router.push({
      name: "notice",
    });
  }

  private handleClick(path: string) {
    window.open(path, "_blank");
  }
  private created() {
    this.$store.dispatch("getTaskCategory");
    if (this.$store.state.userInfo.id) {
      this.$store.dispatch("getRecentList");
    }
    this.getList();
    this.getNotice();
  }
}
